/* src/app/workshop/pages/schedule/schedule.component.scss */
h3 {
  margin: 0 0 10px;
}
pre {
  background-color: #f5f5f5;
  padding: 15px;
}
/*# sourceMappingURL=schedule.component.css.map */
